import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { addActor, selectActors } from "../../app/slices/TrainingSlice";
import ActorPresetList from "./ActorPresetList";
import "./ActorPresetsColumn.css";
import { EditorColumnFooterButton } from "../editor_columns/EditorColumn";
import { ActorHelper } from "./ActorHelper";
import PresetColumnHeader from "../editor_columns/PresetColumnHeader";

/** The actor list, with "Add actor" anchored in a footer like the Storyboard's "Add take". */
export default function ActorPresetsColumn() {
  const dispatch = useDispatch();
  const actors = useSelector(selectActors);
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const onAddNewActor = () => {
    dispatch(addActor(ActorHelper.GetNewRandomActor(actors)));
  };

  return (
    <div className="flex h-full flex-col">
      <PresetColumnHeader
        icon={<PeopleAltOutlinedIcon fontSize="inherit" />}
        title={String(t("actors"))}
        searchPlaceholder={String(t("preset_lists.search_actors"))}
        search={search}
        onSearchChange={setSearch}
        testId="actor-presets-header"
      />
      <div className="min-h-0 flex-1 overflow-hidden">
        <ActorPresetList search={search} />
      </div>
      <div className="flex-shrink-0 p-2.5 border-t border-creator-border">
        <EditorColumnFooterButton
          label="Add actor"
          icon={<PersonAddAltIcon fontSize="inherit" />}
          onClick={onAddNewActor}
          testId="actor-presets-add-actor"
        />
      </div>
    </div>
  );
}
